import { useState } from 'react'
import PropTypes from 'prop-types'
import { withLocalize } from 'react-localize-redux'
import { Modal } from '@material-ui/core'
import styles from './RegenerateKeyContainer.module.scss'
import { showSnackbar } from '../../../../common/actions/snackbar'
import { connect } from 'react-redux'
import { regenerateApiKey } from '../../../../common/actions/systems'

import RegenerateKeyForm from '../components/RegenerateKeyForm'

const RegenerateKeyContainer = props => {
  const [open] = useState(true)

  const { hideModal, system, user, regenerateApiKey } = props
  const { isPremium } = user.toJS()

  const handleSubmit = () => {
    regenerateApiKey(system._id)
    hideModal()
  }

  return (
    <Modal
      open={open}
      onClose={hideModal}
      arial-labelledby='simple-modal-title'
      arial-desccribedby='simple-modal-description'
    >
      <div className={styles.content}>
        <RegenerateKeyForm
          {...props}
          isPremium={isPremium}
          onSubmit={handleSubmit}
          system={system}
        />
      </div>
    </Modal>
  )
}

RegenerateKeyContainer.propTypes = {
  hideModal: PropTypes.func.isRequired,
  translate: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired,
  contentText: PropTypes.string,
  title: PropTypes.string,
  buttonName: PropTypes.string
}
const mapStateToProps = state => ({})

const mapActionsToProps = {
  regenerateApiKey,
  showSnackbar
}

export default withLocalize(connect(mapStateToProps, mapActionsToProps)(RegenerateKeyContainer))
